import React from 'react';
import { Box } from '@mui/material';
import { useSettingsStore } from '@core/store';

interface FieldWithIconProps {
    select: React.ReactNode;
    icon: React.ReactNode | null;
}

const FieldWithIcon: React.FC<FieldWithIconProps> = ({ select, icon }) => {
    const { isMobile } = useSettingsStore();

    if (!icon) return <>{select}</>;

    if (isMobile) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <Box sx={{ flex: 1 }}>{select}</Box>
                <Box sx={{ display: 'flex', alignItems: 'center', height: '40px', mt: '22px', flexShrink: 0 }}>
                    {icon}
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ position: 'relative' }}>
            {select}
            <Box
                sx={{
                    position: 'absolute',
                    top: '22px',
                    left: '100%',
                    height: '40px',
                    ml: 1,
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                {icon}
            </Box>
        </Box>
    );
};

export default FieldWithIcon;
